// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar-module--navbar--PzSrz","logolink":"Navbar-module--logolink--280LO","logotitle":"Navbar-module--logotitle--1AUH-","menu":"Navbar-module--menu--XT5Hv"};